import { Idea } from "../../../w2d2d-api-client";
import { User } from "../../../../appfw/api-client/AppFwApiClient";
import { ideaToEvent } from "../../../ideas/idea-to-event";
import { EventCard } from "../events/EventCard";
import { useContext, useEffect, useState } from "react";
import { ResourceWrapper } from "../../../../eventer-pod/client/ResourceWrapper";
import Session from "../../../../appfw/authentication/Session";
import { SessionContext } from "../../../../appfw/authentication/SessionProvider";
import { useW2d2dPod } from "../../hooks/useW2d2dPod";
import { getPodNameFromUri } from "../../../ideas/idea-uri-utils";

interface IdeaPageEntryProps {
    readonly user: User;
    readonly idea: Idea;
}

export default function IdeaPageEntry(props: IdeaPageEntryProps) {
    const session = useContext<undefined | null | Session>(SessionContext)
    const pod = useW2d2dPod()
    const [event, setEvent] = useState<ResourceWrapper | undefined>(undefined)

    useEffect(() => {
        if (!pod || !session?.id) {
            return
        }

        const idea = props.idea
        const sessionId = session.id

        if (idea.eventUri) {
            let active = true
            pod.getResource({ uri: idea.eventUri, sessionId, importOptions: { ifMissing: true } })
                .then((resource) => {
                    if (active) {
                        if (resource) {
                            setEvent(resource)
                        } else {
                            setEvent(ideaToEvent(idea))
                        }
                    }
                })
                .catch((err) => {
                    console.error("Failed to load event:", err)
                    if (active) {
                        setEvent(ideaToEvent(idea))
                    }
                })
            return () => {
                active = false
            }
        } else {
            setEvent(ideaToEvent(idea))
        }
    }, [pod, props.idea, session])

    if (!pod || !event) {
        return null
    }

    const remotePodName = props.idea.eventUri ? getPodNameFromUri(props.idea.eventUri) : null;

    return <EventCard pod={pod} event={event} idea={props.idea} remotePod={remotePodName} />
}
